import { Box, Grid2 as Grid, Paper, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ImageCarousel from "../../../components/carousel/ImageCarousel";
import moment from "moment";
import { STRING_SPLIT_CHAR } from "../../../utils/stringUtils";
import { ITicketDisplay } from "../../../models/ticket/ticketDisplay";
import Toolbar from "../../../components/toolbar/Toolbar";
import ticketService from "../../../services/ticket/TicketService";
import { saveAs } from 'file-saver';

function base64ToArrayBuffer(base64: string) {
  var binaryString = atob(base64);
  var bytes = new Uint8Array(binaryString.length);
  for (var i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

const DetailedTicketPage = () => {

  const { t } = useTranslation();
  const location = useLocation();
  const ticket = (location.state) as ITicketDisplay;

  const onDownloadPDF = () => {
    ticketService.GetTicketPDF(ticket.id).then((streamPdf) => {
      const bytesArray = base64ToArrayBuffer(streamPdf)
      const blob = new Blob([bytesArray], { type: 'application/pdf' });
      saveAs(blob, `ticket_${ticket.number}.pdf`);
    })
  }

  return (
    <Box>
      <Toolbar
        downloadButtons={[
          { label: "PDF", onClick: () => onDownloadPDF() }
        ]}
      />

      <Grid container justifyContent="space-around" marginY={2} marginTop={6}>
        <Grid component={Paper} size={{ md: 4 }} sx={{ display: "flex", justifyContent: 'center', padding: 4 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <Typography><b>{t(`table.employeeFeedback.ticketNumber`)}:</b> {ticket.number}</Typography>
            <Typography><b>{t(`table.employeeFeedback.date`)}:</b> {moment.utc(ticket.date).local().format("LLL")}</Typography>
            <Typography><b>{t(`header.building`)}:</b> {ticket.buildingName}</Typography>
            <Typography><b>{t(`header.room`)}:</b> {ticket.localName}</Typography>
            <Typography><b>{t(`header.floor`)}:</b> {ticket.floorName}</Typography>
            <Typography><b>{t(`table.employeeFeedback.employee`)}:</b> {ticket.userName}</Typography>
            <Typography><b>{t(`table.employeeFeedback.comment`)}:</b> {ticket.request}</Typography>
          </Box>
        </Grid>

        {ticket.imageKeys &&
          <Grid component={Paper} size={{ xs: 12, md: 6 }} alignContent={"center"}>
            <ImageCarousel sx={{ width: "40%", pb: 4, margin: "auto" }}>
              {ticket.imageKeys.split(STRING_SPLIT_CHAR).map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`image-${index}`}
                />
              ))}
            </ImageCarousel>
          </Grid>
        }
      </Grid>
    </Box>

  );
};
export default DetailedTicketPage;
